import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useStores} from "../../../../stores/Context";
import {useParams} from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import WidgetConsignesContentPhotoCamera from "./WidgetConsignesContentPhotoCamera";

const WidgetConsignesContentPhoto = () => {
    const {widgetStore, consignesStore} = useStores();
    const {id, ent} = useParams();
    const [loadPhotos, setLoadPhotos] = useState(true)
    const [listPhotos, setListPhotos] = useState([]);
    const [isDeleteImg, setIsDeleteImg] = useState([])
    const ModalObject = withReactContent(Swal);

    useEffect(() => {
        if (loadPhotos) {
            axios.get(process.env.REACT_APP_API_URL + '/api/getAllConsignesPhotosByIdTotem/' + widgetStore.idTotem,
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            ).then((res) => {
                setListPhotos(res.data)
                setLoadPhotos(false)
            });
        }
    }, [loadPhotos])

    const toggleDelete = (index) => {
        setIsDeleteImg((prevShowElements) => {
            const newShowElements = [...prevShowElements];
            newShowElements[index] = !newShowElements[index];
            return newShowElements;
        });
    }

    const handleDeletePhoto = (id) => {
        axios.post(process.env.REACT_APP_API_URL + '/api/deletePhoto', {
            id: id
        }, {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}})
            .then((res) => {
                setLoadPhotos(true)
            })
    }

    const handleOpenCamera = () => {

        ModalObject.fire({
            width: 500,
            allowOutsideClick: false,
            text: 'Disponible prochainement',
            showDenyButton: false,
            showCancelButton: true,
            showConfirmButton: false,
            confirmButtonText: 'Valider',
            confirmButtonColor: '#1976d2',
            cancelButtonText: 'Fermer',
        })
    }

    return (
        <div className={"consigneModifyBody"}>

            <div className={"consigneModifyHeader"}>


                <h1 className={"consigneModifyTitleH3"}>Photos enregistrées</h1>
                <div onClick={() => consignesStore.resetViews()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B"
                              stroke-width="2"/>
                        <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B"
                              stroke-width="2"/>
                        <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B"
                              stroke-width="2"/>
                    </svg>
                </div>
            </div>

            <div className={"consigneModifyHeaderSeparateur"}></div>
            <div className={"consigneModifyBodyContent"}>

                <div>
                    {
                        listPhotos.length >= 3 ? (
                            <button className={"consignePhotoTakePhotoBtn consignePhotoTakePhotoBtnDisabled"}
                                    type={"button"}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.66602 5H5.83268L7.49935 2.5H12.4993L14.166 5H18.3327V17.5H1.66602V5Z"
                                          stroke="#A8B0B3" stroke-width="2"/>
                                    <circle cx="9.99935" cy="10.8333" r="3.33333" stroke="#A8B0B3" stroke-width="2"/>
                                </svg>
                                Prendre une photo
                            </button>
                        ) : (
                            <div>
                                {/*<button className={"consignePhotoTakePhotoBtn consignePhotoTakePhotoBtnAdd"} type={"button"}
                                    onClick={handleOpenCamera}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.66699 5H5.83366L7.50033 2.5H12.5003L14.167 5H18.3337V17.5H1.66699V5Z"
                                          stroke="#002335" stroke-width="2"/>
                                    <circle cx="10.0003" cy="10.8333" r="3.33333" stroke="#002335" stroke-width="2"/>
                                </svg>
                                Prendre une photo
                            </button>*/}
                            </div>
                        )
                    }
                </div>
                <div className={"consignePhotoContentList"}>
                    {
                        listPhotos.length > 0 ? (
                            listPhotos.map((data, index) => (
                                <div className={"consignePhotoItem"}>

                                    {
                                        isDeleteImg[index] ? (
                                            <div className={"consignePhotoSuppContent"}>
                                            <span
                                                className={"consigneAddPhotoSuppContentTitle"}>Supprimer cette photo ?</span>
                                                <div className={"consigneAddPhotoSuppContentBtn"}>
                                                    <button className={"consigneAddPhotoSuppContentBtnNon"}
                                                            type={"button"}>Non
                                                    </button>
                                                    <button className={"consigneAddPhotoSuppContentBtnOui"}
                                                            onClick={() => handleDeletePhoto(data.id)}
                                                            type={"button"}>Oui
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <img className={"consigneAddPhotoImg"} src={data.image}/>
                                        )
                                    }


                                    <div className={"consignePhotoFooter"}>
                                                <span className={"consigneAddPhotoDate"}>
                                                    {'Ajouté le ' + data.created_at}
                                                </span>
                                        <div onClick={() => toggleDelete(index)}>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3.30907 16.1485L2.71824 4.33203H17.2824L16.6916 16.1485C16.6118 17.7451 15.294 18.9987 13.6953 18.9987H6.30532C4.7067 18.9987 3.3889 17.7451 3.30907 16.1485Z"
                                                    stroke="#F82121" stroke-width="2"/>
                                                <path
                                                    d="M6.83301 4H13.1663V3C13.1663 1.89543 12.2709 1 11.1663 1H8.83301C7.72844 1 6.83301 1.89543 6.83301 3V4Z"
                                                    stroke="#F82121" stroke-width="2"/>
                                                <path d="M0.833008 4.16797H19.1663" stroke="#F82121"
                                                      stroke-width="2"/>
                                                <path d="M12.5 9.16797V13.3346" stroke="#F82121" stroke-width="2"/>
                                                <path d="M7.5 9.16797V13.3346" stroke="#F82121" stroke-width="2"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                            ))
                        ) : (
                            <div style={{height: "5em", display: "flex", alignItems: "center"}}>Aucune photo
                                disponible</div>
                        )

                    }
                </div>

            </div>


            {
                listPhotos.length >= 3 ? (
                    <div className={"consignePhotoLimiteContent"}>
                        <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="icons MASTER">
                                <circle id="Ellipse 95" cx="20" cy="19.9961" r="19" fill="#002335"/>
                                <path id="aide"
                                      d="M18.45 25.6241C18.1967 25.6241 17.9813 25.5481 17.804 25.3961C17.6267 25.2188 17.538 24.9908 17.538 24.7121V7.30809C17.538 7.05476 17.6267 6.83943 17.804 6.66209C17.9813 6.48476 18.1967 6.39609 18.45 6.39609H21.528C21.8067 6.39609 22.022 6.48476 22.174 6.66209C22.3513 6.83943 22.44 7.05476 22.44 7.30809V24.7121C22.44 24.9908 22.3513 25.2188 22.174 25.3961C22.022 25.5481 21.8067 25.6241 21.528 25.6241H18.45ZM18.222 32.9961C17.9433 32.9961 17.7153 32.9074 17.538 32.7301C17.386 32.5528 17.31 32.3374 17.31 32.0841V28.5501C17.31 28.2714 17.386 28.0434 17.538 27.8661C17.7153 27.6888 17.9433 27.6001 18.222 27.6001H21.756C22.0347 27.6001 22.2627 27.6888 22.44 27.8661C22.6173 28.0434 22.706 28.2714 22.706 28.5501V32.0841C22.706 32.3374 22.6173 32.5528 22.44 32.7301C22.2627 32.9074 22.0347 32.9961 21.756 32.9961H18.222Z"
                                      fill="#FBFDFE"/>
                            </g>
                        </svg>

                        <h3 className={"consignePhotoTitleH3"}>Limite de photos atteinte</h3>
                        <span className={"consignePhotoLimiteSpan"}>Veuillez supprimer des photos avant d'en ajouter d’autres.</span>
                    </div>
                ) : null
            }


            {
                /*
                <div className={"bntPhotoContent"}>
                <button className={`btnMenuPhoto btnViewCamera ${menuCamera ? "btnMenuPhotoActive" : ""}`}
                        variant={"none"} onClick={handleViewCamera}>
                    <FontAwesomeIcon icon={faCamera} style={{fontSize: "1.2em", marginRight: "0.5em"}}/>
                    Camera
                </button>
                <button className={`btnMenuPhoto btnViewList ${menuAlbum ? "btnMenuPhotoActive" : ""}`}
                        onClick={handleViewAlbum}>
                    <FontAwesomeIcon icon={faPhotoVideo} style={{fontSize: "1.2em", marginRight: "0.5em"}}/>
                    Photos enregistrées
                </button>
            </div>
            {
                isCamera ? (<WidgetConsignesContentPhotoCamera/>) : (<WidgetConsignesContentPhotoList/>)
            }
                 */
            }

        </div>
    );
};

export default WidgetConsignesContentPhoto;